import { AgentTooltip } from "fe-common/ui/AgentTooltip";
import * as React from "react";
import styled from "@mui/material/styles/styled";
import { ReactComponent as ClinicalReasoningIconSVG } from "../../../assets/clinicalReasoningIcon.svg";
import { useState } from "react";

const HelpIcon = styled("span")(({ theme }) => ({
  opacity: 1,
  display: "flex",
  textAlign: "center",
  alignItems: "center",
}));

export const NextStepByDiseaseInfo = (props: {
  title: Exclude<React.ReactNode, null | undefined>;
  openOnClick?: boolean;
}) => {
  const [open, setOpen] = useState(false);

  if (!props.title) return null;

  const onClick = () => {
    setOpen(!open);
  };

  return props.openOnClick ? (
    <AgentTooltip title={props.title} open={open}>
      <HelpIcon onClick={onClick}>
        <ClinicalReasoningIconSVG fontSize={"small"} />
      </HelpIcon>
    </AgentTooltip>
  ) : (
    <AgentTooltip title={props.title}>
      <HelpIcon onClick={onClick}>
        <ClinicalReasoningIconSVG fontSize={"small"} />
      </HelpIcon>
    </AgentTooltip>
  );
};
